import { lazy, Suspense } from 'react';
import { LoadingScreen } from '@syntra/ui/components/loading-screen';

// ----------------------------------------------------------------------

const Auth0CallbackPage = lazy(() => import('src/pages/auth/auth0-callback'));

// ----------------------------------------------------------------------

export const authRoutes = [
  {
    path: 'auth',
    children: [
      // The API redirects here after the Auth0 login (AUTH0_LOGIN_REDIRECT_URL)
      {
        path: 'auth0/callback',
        element: (
          <Suspense fallback={<LoadingScreen />}>
            <Auth0CallbackPage />
          </Suspense>
        ),
      },
    ],
  },
];
